import { transfers_table_header_cells } from "../../assets/data"
import TransfersHeaderCell from "./TransfersHeaderCell"



export default function TransfersHeader() {
    
    return <thead>
        <tr>
            {transfers_table_header_cells && transfers_table_header_cells.map(item => (
                <td key={item.id} >
                    <TransfersHeaderCell item={item}/>
                </td>
            ))}
        </tr>
    </thead>
}